import { Component, ViewEncapsulation, OnInit, OnDestroy, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MCButtonComponent } from '@maslul/common-components';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'mi-app-menu',
    imports: [
        NgClass,
        RouterModule,
        MCButtonComponent
    ],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit, OnDestroy {
  private translateService = inject(TranslateService);

  sidebarVisible: boolean = false;
  subscription: Subscription = new Subscription();
  menuText: any;
  isCloseLanguage: boolean = true;
  isCloseHelpInformation: boolean = true;


  ngOnInit(): void {
    this.initText();


  }

  initText() {

    this.subscription.add(this.translateService.stream('menu').subscribe(translation => {
      this.menuText = translation;
    }));

  }

  toggleMenu(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }

  closeMenu(): void {
    this.sidebarVisible = false;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  toggleLanguage() {
    this.isCloseLanguage = !this.isCloseLanguage
  }
  toggleHelpInformation() {
    this.isCloseHelpInformation = !this.isCloseHelpInformation;
  }
}
